import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faWifi} from '@fortawesome/free-solid-svg-icons/faWifi'
import {Badge} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {useContextSelector} from 'use-context-selector';
import {LocalContext} from '../context/LocalContext';

const NetworkConnectivityIndicator = (props) => {
    const {t} = useTranslation();

    const clientOnline = useContextSelector(LocalContext, v => v[0].clientOnline);

    return <>
        {
            !(clientOnline && props.hideOnline) ?
                <Badge
                    variant={clientOnline ? 'primary' : 'warning'}
                    className={`align-self-center ${props.className ? props.className : null}`}
                    style={
                        {
                            lineHeight: 1,
                            overflow: `hidden`,
                            ...props.style ? props.style : {}
                        }
                    }
                >
                    <FontAwesomeIcon icon={faWifi} />
                    <span
                        className="ml-1"
                    >{clientOnline ? t('NetworkConnectivityIndicator.online') : t('NetworkConnectivityIndicator.offline')}</span>
                </Badge> :
                null
        }
    </>
}

export default NetworkConnectivityIndicator;
